<template>
  <div class="block-n">
    <div class="block-n__letter letter letter-line" data-aos="fade-up">
      Н.
    </div>
    <div class="block-n__row">
      <div class="block-n__head block-n__head--1">
        <div class="block-n__title block-n__title--1" data-aos="fade-right">Непереносимость</div>
        <div class="block-n__title block-n__title--2" data-aos="fade-right"><span><i>*</i> intolerance to</span></div>
      </div>
      <div class="block-n__head block-n__head--2">
        <div class="block-n__title block-n__title--4" data-aos="fade-left">английской речи</div>
        <div class="block-n__title block-n__title--3" data-aos="fade-left"><span>English speech</span></div>
      </div>
    </div>
    <div class="block-n__text text-white" data-aos="fade-up">После ряда успешных выступлений в Нью-Йорке Вертинскому поступило предложение сняться <br>в кино в Голливуде. Но вот беда — артист отлично знал и немецкий, и французский, но английский язык — «на дух не переносил». Небезызвестная подруга Вертинского Марлен Дитрих настоятельно рекомендовала ему «преодолеть отвращение любого нормального человека и взять себя в руки», но с такой задачей Вертинский справиться так и не смог. Поэтому и поступил, как настоящий русский, столкнувшийся с невероятно прекрасной возможностью — отказался.</div>
    <div class="block-n__quote">„Жить вдали от Родины в момент, когда она обливается кровью, и быть бессильным ей помочь — самое ужасное“</div>
  </div>
</template>

<script>
export default {
  name: 'BlockV'
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .bg-black
      &:after
        background-size: vwm(150px)
        opacity: 0.02
    .block-n
      &__quote
        font-family: 'Aphrosine'
        font-size: vwm(50px)
        line-height: vwm(40px)
        margin-top: vwm(80px)
        font-style: italic
        text-align: center
      &__letter
        margin-top: vwm(-84px)
        background-color: #000
        margin-bottom: vwm(51px)
      &__row
        flex-direction: column
      &__text
        text-align: left
        width: vwm(340px)
        margin-top: vwm(44px)
        font-size: vwm(17px)
        line-height: vwm(22.3px)
        br
          display: none
      &__head
        flex-direction: column
      &__title
        font-size: vwm(40px)
        text-align: left
        padding-left: vwm(17px)
        margin-bottom: vwm(12px)
        &--2
          letter-spacing: vwm(2.5px)
          margin-bottom: vwm(-11px)
        &--4
          letter-spacing: vwm(-0.4px)
          text-align: right
          padding-right: vwm(25px)
        &--3
          letter-spacing: vwm(2.2px)
          padding-left: vwm(23px)

</style>
